import { gql } from '@apollo/client';

export type OnBoarding = {
  patientSymptoms: string;
  frequentlyOfSymptoms: string;
  usedHeartMonitor: boolean;
  pacer: boolean;
};

const OnBoardingFragment = gql`
  fragment OnBoardingFragment on PatientOnBoarding {
    patientSymptoms
    frequentlyOfSymptoms
    usedHeartMonitor
    pacer
  }
`;

export default OnBoardingFragment;
